import { UPLOAD_SINGLE_SUCCESS } from '../actions/actionTypes';

export default function uploadedSingle(state = {}, action) {
  switch (action.type) {
    case UPLOAD_SINGLE_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
